import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { contextConnect, useContextSystem } from '@wp-g2/context';
import { cx } from '@wp-g2/styles';
import React from 'react';
import * as styles from './List.styles';
var ListView = styles.ListView;

function List(props, forwardedRef) {
  var _useContextSystem = useContextSystem(props, 'List'),
      className = _useContextSystem.className,
      _useContextSystem$typ = _useContextSystem.type,
      type = _useContextSystem$typ === void 0 ? 'unordered' : _useContextSystem$typ,
      otherProps = _objectWithoutProperties(_useContextSystem, ["className", "type"]);

  var isNumber = type === 'ordered';
  var asProp = isNumber ? 'ol' : 'ul';
  var classes = cx(isNumber && styles.ordered, className);
  return /*#__PURE__*/React.createElement(ListView, Object.assign({
    as: asProp
  }, otherProps, {
    className: classes,
    ref: forwardedRef
  }));
}

export default contextConnect(List, 'List');